import { initLanguage } from 'zn-i18n'

// 从本地存储中获取语言标识
const getLanguageByLocalStorage = () => window.localStorage.getItem('browserLanguage') || null

// 从浏览器对象中获取语言标识
const getLanguageByNavigator = () => {
  const { language } = window.navigator
  // 统一转换成小写
  const lowerLang = language.toLowerCase()
  const arr = lowerLang.split('-')
  // 繁体zh-TW、zh-HK, 简体zh-CN、zh
  if (arr[0] === 'zh' && arr[1]) {
    return arr[1] === 'cn' ? 'zh' : 'tw'
  }
  // zh、en
  return arr[0]
}

// 获取当前语言标识
export const getCurrentLanguage = () => {
  let res: string|null = null
  res = getLanguageByLocalStorage()
  if (res) {
    return res
  }
  res = getLanguageByNavigator()
  if (res) {
    return res
  }
  return ''
}

/**
 * 初始化国际化插件
 * @param langDirPath 语言包目录路径
 */
export const initI18n = async (langDirPath: string): Promise<void> => {
  // 当前浏览器语言标识(标准应与老中台同步)
  const lang = getCurrentLanguage()
  // 加载语言
  await initLanguage(
    {
      // 语言标识列表
      langList: ['zh', 'en', 'tw', 'th'],
      // 默认语言标识(开发时的文本语言)
      defLang: 'zh',
      // 语言包目录路径
      langDirPath,
      // 语言转换函数名
      funcName: 'zn_t_intelligent_portal',
      lang,
      // 存储前缀
      storagePrefix: '__lang_intelligent_portal_'
    }
  )
}
